import React from 'react';
import {observer, Observer, inject} from 'mobx-react';
import {toJS, action} from 'mobx';
import moment from 'moment';
import * as constants from '../../model/const';

import {SiteHeader} from '../component/SiteHeader';
import {SiteFooter} from '../component/SiteFooter';

import {BWStepBar} from '../component/BWStepBar';
import {BWReceipt} from '../component/BWReceipt';

import { fmtPrice, fmtPercent, fmtDatetime, fmtDate, fmtTime } from '../../model/formatters';
import translateBase from '../../translate';
let translate = translateBase.bindPage('bw07BookingFinished');

@inject(stores => ({ 
  navigation: stores.app.navigation,
  rentalTransaction: stores.app.rentalTransaction,
  vPayment: stores.app.vPayment,
  vFinished: stores.app.vFinished,
  authentication: stores.app.authentication,
  //rentalObject: stores.app.rentalObject,
  businessUnit: stores.app.businessUnit,
}))
@observer
export class BWFinished extends React.Component {

  render() {
    const {navigation, rentalTransaction, vPayment, vFinished, businessUnit, authentication} = this.props;
    const {message} = vFinished;
    const currency = businessUnit.currencyName; //"CHF"; 
    return (
      <div>
        <SiteHeader />

        <BWStepBar activeStep={7} showAllSteps />

        {/*<BWReceipt /> */}

        <section className="wizard-container booking-view">
            <div className="wrapper">
                
                <div className="row wizard-content">
                    <div className="column-12">
                        <h3 className="mali-blue">{translate("confirmation", "Bestätigung")}</h3>
                        
                        <div className="success-container">
                            <div className="row">
                                <div className="success-content column-6 offset-3">
                                    <h4>{translate("bookingFor", "Die Buchung für")} <span>{vFinished.objectName}</span> {translate("fromDate", "vom")} <span>{fmtDatetime(vFinished.bookingStartDate)}</span> {translate("toDate", "bis")} <span>{fmtDatetime(vFinished.bookingEndDate)}</span> {translate("forPrice", "für")} <span>{currency} {fmtPrice(vFinished.bookingPrice)}</span> {translate("wasFinished", "wurde erfolgreich abgeschlossen.")}</h4>
                                    <h4>{translate("bookingDetailsSent", "Die Buchungsdetails und die Rechnung wurden an Ihre E-Mail Adresse gesandt.")}</h4>
                                    {message && <h4>{message}</h4>}
                                    {authentication.isLoggedIn && <a href="#/userRegistration/1">{translate("performRegister", "Register")}</a>}
                                    <a className="pdf" href={`/api/${vFinished.isGuestTransaction ? 'public': 'Lessee'}/RentalTransaction/${vFinished.trxId}/BillReport`} target="_blank">{translate("performPrint", "Bestätigung drucken")} <i className="fa fa-print" aria-hidden="true"></i></a>
                                    <a id="btn-bwfin-gohome" className="home" href="#/home">{translate("goHome", "Startseite")} <i className="fa fa-check" aria-hidden="true"></i></a>
                                </div>
                            </div>
                        </div>
        
                    </div> 
                </div>
        
            </div>
        </section>

        <SiteFooter />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/visual/view/BWFinished.js